import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { SelectedModuleContext } from '../../../constants/acl-config';
import ModulesMenu from './ModulesMenu';
import SelectedModuleMenu from './SelectedModuleMenu';

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  background: #ffffff;
  color: #656668;
`;

function SidebarMenu() {
  const [selectedModule, setSelectedModule] = useState();
  const memoizedSelectedModule = useMemo(() => ({ selectedModule, setSelectedModule }), [selectedModule]);

  return (
    <SelectedModuleContext.Provider value={memoizedSelectedModule}>
      <Wrapper>
        <ModulesMenu />
        <SelectedModuleMenu />
      </Wrapper>
    </SelectedModuleContext.Provider>
  );
}

export default SidebarMenu;
